import React from 'react';
import type {SetOptional} from 'type-fest';
import {i18n} from '@netx/core/i18n';
import {faTrashAlt} from '@netx/core-icons';
import {
	IconButtonToggle,
	type IconButtonToggleProps,
} from '@netx/core-components/IconButtonToggle';

export * from '@netx/core-components/IconButtonToggle/iconButtonToggleClasses';

export interface ClearToggleProps extends SetOptional<
	IconButtonToggleProps,
	'icon' | 'label'
> {}

export const ClearTogglePrimitive = (
	{disabled, label, ...props}: ClearToggleProps,
	ref: React.ForwardedRef<HTMLButtonElement>,
) => {
	return (
		<IconButtonToggle
			ref={ref}
			data-testid="clear-toggle"
			aria-label="toggle delete"
			disabled={disabled}
			icon={faTrashAlt}
			label={label ?? (!disabled ? i18n.t('i18n.deleteValues') : '')}
			{...props}
		/>
	);
};

export const ClearToggle = React.forwardRef<
	HTMLButtonElement,
	ClearToggleProps
>(ClearTogglePrimitive) as (
	props: ClearToggleProps & {ref?: React.ForwardedRef<HTMLButtonElement>},
) => JSX.Element;

export default React.memo(ClearToggle);
